import React, { lazy } from 'react'
import type { RouteObject } from 'react-router'

const Browse = lazy(() => import('./Browse'))
const Detail = lazy(() => import('./Detail'))

const routes: RouteObject[] = [
    {
        path: '/risks',
        element: <Browse />
    },
    {
        path: '/risks/detail/:index',
        element: <Detail />
    }
]

export default routes
